/**
 * Increments the current value by 1.
 *
 * @param {number|string} x - Current value.
 * @returns {number}
 */
export function inc(x) {
  return Number(x) + 1;
}
